const neighborhoodsKeys = {
  module: ['neighborhoods'] as const,
  list: () => [...neighborhoodsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...neighborhoodsKeys.list(), filters] as const,
  details: (id: string) =>
    [...neighborhoodsKeys.module, 'details', id] as const,
  cities: (cityId: string) =>
    [...neighborhoodsKeys.module, 'cities', cityId] as const,
  companies: (companyId: string) =>
    [...neighborhoodsKeys.module, 'companies', companyId] as const,
};

export default neighborhoodsKeys;
